import { 
    BULK_GET_FAILURE,
    BULK_GET_REQUEST,
    BULK_GET_SUCCESS,} from "../actions/actionTypes";

const initialState = {
  bulkPriceTransaction: [],
  loading: false,
  error: null,
};

const bulkPriceTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case BULK_GET_REQUEST:
      return { ...state, loading: true, error: null };
      
    case BULK_GET_SUCCESS:
      return { ...state, loading: false, bulkPriceTransaction: action.payload.data };

    case BULK_GET_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default bulkPriceTransactionReducer;
